export interface ErrorBannerProps {
  message: string;
  onRetry: () => void;
}

export default function ErrorBanner({ message, onRetry }: ErrorBannerProps) {
  return (
    <div
      role="status"
      className="flex w-full flex-wrap items-center gap-2 border-b border-yellow-200 bg-yellow-50 px-4 py-2 text-body-medium text-yellow-900"
    >
      <span className="min-w-0 flex-1">{message}</span>
      <button
        type="button"
        onClick={onRetry}
        className="shrink-0 rounded-md bg-yellow-800 px-3 py-1.5 text-label-large font-medium text-yellow-50 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
      >
        Retry
      </button>
    </div>
  );
}
